import type {
  CustomFieldSettings,
  CustomFieldType,
} from '@tribeplatform/gql-client/types'

type ViewStyles = 'gallery' | 'card' | 'list' | 'carousel' | 'magazine'

export enum StaticFieldTypes {
  avatar = 'avatar',
  banner = 'banner',
  title = 'title',
  button = 'button',
  info = 'info',
}
export interface ViewField {
  id: string
  enabled: boolean
  fields?: ViewField[]
  settings: {
    customFieldSettings?: CustomFieldSettings[]
    stretchX?: boolean
    stretchY?: boolean
    fullWidth?: boolean
    snapBottom?: boolean
    bannerStyle?: 'banner' | 'square'
    bannerSource?: string
    avatarSize?: 'md' | 'lg' | 'xl'
    titleSize?: 'sm' | 'md' | 'lg'
    showSpaceName?: boolean
    buttonVariant?: 'icon' | 'text' | 'iconText'
    showReactionCount?: boolean
    showReplyCount?: boolean
    showFollowCount?: boolean
    showPostOptions?: boolean
    aspectRatio?: string
    truncateSize?: 'sm' | 'md' | 'lg'
    displayStyle?: 'full' | 'truncated' | 'expandable'
    showBackToSpaceButton?: boolean
    linkStyle?: 'link' | 'button'
    openInNewWindow?: boolean
    buttonSize?: 'sm' | 'md' | 'lg'
  }
  isStatic: boolean
}

export interface StaticField extends ViewField {
  label: string
  locked: boolean
  type?: CustomFieldType | StaticFieldTypes
  styles?: ViewStyles[]
  icon?: JSX.Element
  fields?: StaticField[]
  default?: string
}

export interface View {
  id: string
  name: string
  style: ViewStyles
  gallerySize?: 'small' | 'medium' | 'large'
  showDivider?: boolean
  fields: ViewField[]
}

export type MultiViewBlockProps<T> = {
  views: T[]
  title: string
  description: string
  linkText: string
  linkUrl: string
}

export type SetProperties<T> = (props: Partial<T>) => void
interface ViewSettingsProps<T> {
  view: T
  compiledView: T
  setProperties: SetProperties<T>
  goBack: () => void
}

export type ViewSettingsComponent<T> = (
  props: ViewSettingsProps<T>,
) => JSX.Element

export type SetFieldProperty = <T extends keyof ViewField>(
  key: T,
  value: ViewField[T],
) => void

export type GetFieldSettings = <T extends keyof ViewField['settings']>(
  key: T,
) => ViewField['settings'][T]
export type SetFieldSettings = <T extends keyof ViewField['settings']>(
  key: T,
  value: ViewField['settings'][T],
) => void
